<style scoped>
</style>

<template>
  <div style="background:#fff;padding:15px;">
    <Breadcrumb style="margin-left:15px;">
        <BreadcrumbItem to="/vreleasemanage">首页</BreadcrumbItem>
        <BreadcrumbItem >审核</BreadcrumbItem>
    </Breadcrumb>

    <Steps :current="formItem.step"  style="padding:0px 80px; margin-top:44px; margin-bottom: ">
        <Step title="准备审核" content="已开始" ></Step>
        <Step title="基础信息审核" content="进行中" ></Step>
        <Step title="单元测试审核" content="未开始"></Step>
        <Step title="人工测试审核" content="未开始"></Step>
        <Step v-if="formItem.type != 2" title="集成测试审核" content="未开始"></Step>
        <Step v-if="formItem.type != 2" title="模拟升级测试审核" content="未开始"></Step>
    </Steps>

    
    <Form :model="formItem" :label-width="80" style="margin-top:20px;">
        <FormItem label-width="150" label="组件名称：" >
            {{ formItem.name }}
        </FormItem>
        <FormItem label-width="150" label="版本号：" >
            {{ formItem.version }}
        </FormItem>
        <FormItem label-width="150" label="构建号：" >
            {{ formItem.buildcode }}
        </FormItem>
        <FormItem label-width="150" label="版本类型：" >
            <Tag v-if="formItem.type==1" color="green" >正式版本</Tag>
            <Tag v-if="formItem.type==2" color="orange" >sp版本</Tag>
        </FormItem>
        <FormItem label-width="150" label="更新内容：" >
            <div v-for="(item, index) in formItem.contents" v-bind:key="index">
                {{ index+1 }}、
                <Tag v-if="item.type==0" color="green" >新增</Tag>
                <Tag v-if="item.type==1" color="error" >修复</Tag>
                <Tag v-if="item.type==2" color="orange" >优化</Tag>
                {{ item.description }}
            </div>
        </FormItem>
    </Form>

    <Divider orientation="left">审核区域</Divider>

    <div v-if="examines.info.type > 0" style="padding:0px 80px;" >
        <Form>
            <FormItem label="附件："  >
                <a
                    :href="attachurl"
                    target="_blank"
                >下载</a>
            </FormItem>
            <FormItem label="备注："  >
                    {{ examines.info.mark }}
            </FormItem>
        </Form>
    </div>

    <div style="padding:0px 80px;">
        <div v-for="(item, index) in examines.reasons" v-bind:key="index">
            <Row>
                <Col span="12">
                    <Alert :type="(item.state==1)?'success':'error'" show-icon>错误：{{ item.reason }}</Alert>
                </Col>
                <Col span="12">
                    <Button
                    @click="resolveReaon(item)"
                        v-if="item.state==0"
                        style="margin-left:5px;"
                            type="dashed"
                        >解决</Button>
                </Col>
            </Row>
        </div>
    </div>


    <Form :model="formItem" :label-width="80" style="margin-top:20px;">
        <FormItem label-width="150" label="审核结果：" required >
            <Select v-model="examineForm.result" placeholder="请选择审核结果">
                <Option value="0">不通过</Option>
                <Option value="1">通过</Option>
            </Select>
        </FormItem>
        <FormItem label-width="150" label="拒绝理由：" v-if="examineForm.result=='0'"   required >
            <Input v-model="examineForm.reason" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入您的拒绝原因，需要讲述清晰..."></Input>
        </FormItem>
        <FormItem label-width="150"  >
            <Button v-if="!isUpdate" :disabled="saveBtnIsDisabled" @click="saveForm" type="primary">{{ saveBtnText }}</Button>
        </FormItem>
    </Form>

  </div>
</template>

<script>

import dayjs from 'dayjs';

export default {
  components: {
  },
  data() {
    return {
        saveBtnText:"审核完成",
        saveBtnIsDisabled:false,
        examines:{
            info:{},
            reasons:[],
        },
        examineForm:{
            result:"0",
        },
        formItem:{
            type:'1',
            contents:[]
        },
    };
  },
  methods: {
    initRuntimeRole(){
        let moduleid = this.$route.params.id || "";
        let _this = this;
        // 查询待修改的数据
        this.$http.post({
            method: "mqms/moduledist/findrequestbyid",
            params: {id : moduleid},
            success: function (data) {
                let from = data.obj;
                from.type = from.type + "";
                for (let item of data.list) {
                    item.type = item.type + "";
                }
                from.contents = data.list || [];
                _this.formItem = from;
            },
            failure(code, errMsg) {
                _this.$Message.error({
                    content:errMsg||"数据加载失败"
                })
            },
        });

         this.loadExamineInfo(moduleid);
    },


    loadExamineInfo:function(moduleid){
            let _this = this;
            //如果是审核状态下的修改，需要查询对应的审核信息。
            this.$http.post({
            method: "mqms/moduledist/getAllReasonsByModuleid",
            params: {id : moduleid},
            success: function (data) {
                _this.examines = data;
            },
            failure(code, errMsg) {
                _this.$Message.error({
                    content:errMsg||"审核信息加载失败"
                })
            },
        })
    },

    saveForm(){
        this.saveBtnText = "正在处理...";
        this.saveBtnIsDisabled = true;
        let _this = this;

        let moduleid = this.$route.params.id || "";
        // 查询待修改的数据
        this.$http.post({
            method: "mqms/moduledist/completeexamine",
            params: { id : moduleid, examine:this.examineForm},
            success: function (data) {
                _this.saveBtnText = "审核完成";
                _this.saveBtnIsDisabled = false;
                _this.$Message.success({
                    content:"审核完成"
                })
                _this.$router.push({
                    name:"vreleasemanage"
                })
            },
            failure(code, errMsg) {
                _this.saveBtnText = "审核完成";
                _this.saveBtnIsDisabled = false;
                _this.$Message.error({
                    content:errMsg||"审核失败"
                })
            },
        });
    },

    resolveReaon(row){
        let _this = this;
        let loading = this.$Message.loading({
                    content: '正在处理...',
                    duration: 0
                });
        this.$http.post({
            method: "mqms/moduledist/resolveexaminereason",
            params: { id : row.id,},
            success: function (data) {
                let moduleid = _this.$route.params.id || "";
                _this.loadExamineInfo(moduleid);
                setTimeout(loading, 0)
                _this.$Message.success({
                    content:"已解决"
                })
            },
            failure(code, errMsg) {
                setTimeout(loading, 0)
                _this.$Message.error({
                    content:errMsg||"操作失败"
                })
            },
        });
        
    },
  
  },
  created() {
    this.initRuntimeRole();
  },
};
</script>